// Toggle debugging logs
window.debugMode = false;
function logger(message) {
  if (window.debugMode) {
    console.log("NP", message);
  }
}

window.lpStayAttr = {
  subscriptionChecked: false,
  subscriptionFrequency: 1,
  activePack: 3,
};

// form
const setupForm = () => {
  const changeRegPrice = $(".strikethrough-lg");
  const changeTextSave = $(".text-save");
  const changePercentOffPrice = $(".off-price");
  const changeSalePrice = $(".sale-price");
  const changePieces = $(".v-packs-option");
  const subscriptionSalePrice = $(".subscribe-option .sale-price");

  const currentVariantId = document.querySelector(
    'input[name="packs_variant_id"]'
  );
  const currentPrice = document.querySelector('input[name="packs_price"]');

  const updateFrequencyFromEl = (triggerEl) => {
    const matches = triggerEl.find("option:selected").text().match(/\d+/);
    logger(["updateFrequencyFromEl", triggerEl, matches]);

    // update selected frequency
    // $(".recharge-frequency").val(triggerEl.val());

    var vFrequency = -1;
    if (matches && matches.length > 0) {
      vFrequency = parseInt(matches[0]);
      window.lpStayAttr.subscriptionFrequency = vFrequency;
    }
  };

  const updateUseCase = () => {
    const vPacks = window.lpStayAttr.activePack;
    const vFrequency = window.lpStayAttr.subscriptionFrequency;
    logger(["updateUseCase", vPacks, vFrequency]);

    var vFamilyUseText = "Perfect for everyday usage families with 2 children";
    if (vPacks == 2 || vPacks == 3) {
      if (vFrequency == 1) {
        vFamilyUseText = "Perfect for everyday usage families with 2 children";
      } else if (vFrequency == 2) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      } else if (vFrequency == 3) {
        vFamilyUseText =
          "Perfect for use a few times a week by families with one child";
      }
    } else if (vPacks == 4) {
      if (vFrequency == 1) {
        vFamilyUseText =
          "Perfect for everyday use by families with three children";
      } else if (vFrequency == 2) {
        vFamilyUseText =
          "Perfect for everyday use by families with two or three children";
      } else if (vFrequency == 3) {
        vFamilyUseText = "Perfect for everyday use by families with one child";
      }
    }

    $(".family-use").text(vFamilyUseText);
  };

  const switchSubscriptionPricing = () => {
    logger("switchSubscriptionPricing");
    const listPacks = document.querySelectorAll(".list-packs");

    let priceAttr = "data-price";
    if (window.lpStayAttr.subscriptionChecked) {
      priceAttr = "data-subscription-price";
    }

    listPacks.forEach((listPack) => {
      const pack = listPack.getAttribute("data-pack");
      const packPrice = listPack.querySelector(".pack-price");
      const regPrice = listPack.querySelector(`.reg-price-${pack}`);
      const savePrice = listPack.querySelector(`.save-price-${pack}`);
      const savePercent = listPack.querySelector(`.save-percent-${pack}`);

      packPrice.innerText = packPrice.getAttribute(priceAttr);
      regPrice.innerText = regPrice.getAttribute(priceAttr);
      savePrice.innerText = savePrice.getAttribute(priceAttr);
      savePercent.innerText = savePercent.getAttribute(priceAttr);
    });
  };

  const updateActivePrices = () => {
    const pack = window.lpStayAttr.activePack;
    logger(["updateActivePrices", pack]);

    $(".list-packs").removeClass("active-slide");

    if (pack == 1) {
      $(".np-multiple-pack").hide();
      $(".np-one-pack").show();
    } else {
      $(".np-multiple-pack").show();
      $(".np-one-pack").hide();
    }

    const listPacks = document.querySelectorAll(
      `.list-packs[data-pack="${pack}"]`
    );

    let priceAttr = "data-price";
    if (window.lpStayAttr.subscriptionChecked) {
      priceAttr = "data-subscription-price";
    }

    listPacks.forEach((listPack) => {
      changeRegPrice.html(
        listPack.querySelector(`.reg-price-${pack}`).getAttribute(priceAttr)
      );
      changePercentOffPrice.html(
        listPack.querySelector(`.save-percent-${pack}`).getAttribute(priceAttr)
      );
      changeSalePrice.html(
        listPack.querySelector(`.save-price-${pack}`).getAttribute(priceAttr)
      );
      changeTextSave.html(
        listPack.querySelector(`.text-save-${pack}`).getAttribute(priceAttr)
      );
      changePieces.html(listPack.querySelector(`.pcs-${pack}`).innerHTML);
      subscriptionSalePrice.html(
        listPack
        .querySelector(`.save-price-${pack}`)
        .getAttribute("data-subscription-price")
        );
        
      currentVariantId.value = listPack.getAttribute("data-id");
      listPack.classList.add("active-slide");
    });
  };

  // default
  updateActivePrices();
  updateUseCase();

  // change active pack
  $(".list-packs").on("click", function (e) {
    logger("list-packs click");
    e.preventDefault();
    e.stopPropagation();
    window.lpStayAttr.activePack = $(this).attr("data-pack");

    // if data-pack is 1
    if (window.lpStayAttr.activePack == 1) {
      logger("list-packs[data-pack='1'] click");
      $(".np-multiple-pack").hide();
      $(".rtx-subscribe-label").prop("checked", false);
      $(".rtx-frequency").val($(".rtx-frequency option:first").val());
      $(".subscribe-frequency").hide();
      $(".np-one-pack").show();
      $(".hide-price-pack").hide();
      resetSelectedSubscription()
    } else {
      if (window.lpStayAttr.subscriptionChecked == true) {
        $(".subscribe-frequency").show();
        $(".np-multiple-pack").show();
      } 
      
      $(".hide-price-pack").show();
    }

    updateActivePrices();
  });

  // add to cart
  $(".button-proceed").on("click", function (e) {
    logger("button-proceed click");
    e.preventDefault();
    e.stopPropagation();

    let stayFrequency = '';
    const targetEl = e.target.parentElement
    const frequencyEl = targetEl.querySelector('.rtx-frequency');
    const frequency = frequencyEl?.value

    if ($("#rtxSubscribe").is(":checked")) {
      const mainFrequencyVal = $(".rtx-frequency").val()
      stayFrequency = frequency || mainFrequencyVal;
    }

    addItemToCart(currentVariantId.value, 1, stayFrequency);
    return false;
  });

  const productHandle = window.product.handle;
  $.getJSON(
    `${window.Shopify.routes.root}products/${productHandle}.js`,
    (product) => {
      const staySelligPlan = product.selling_plan_groups.find((plan) => plan.app_id === '5859381')
      if (product.selling_plan_groups.length < 0 && !staySelligPlan) {
        $(".stay-container").hide();
        return;
      }

      const sellingPlans = staySelligPlan.selling_plans;
      sellingPlans.forEach((plan) => {
        const planValue = plan.options[0].value.toLowerCase()
        const frequency = planValue.split(' ')[0]
        if (planValue.includes('week') || (Number(frequency) && Number(frequency) > 3) ) return
        const option = document.createElement("option");
        option.value = plan.id;
        option.text = plan.name.replace("Delivery e", "E");
        $(".rtx-frequency").append(option);
      });
    }
  );


  /**
   * Removes the iCart element
   */
  const removeICart = () => {
    $('body > .icart').remove();
  };
  

  // based on
  // https://support.rechargepayments.com/hc/en-us/articles/360008683774-Adding-an-item-to-the-cart-with-AJAX
  function addItemToCart(variant_id, qty, selling_plan) {
    logger(["addItemToCart", variant_id, qty, selling_plan]);
    data = {
      id: variant_id,
      quantity: qty,
      selling_plan: selling_plan
    };
    if (selling_plan > 0) {
      data["selling_plan"] = selling_plan;
    }
    logger(["data", data]);

    const product = window.product;

    // fbq_data = {
    //   content_name: product.title,
    //   content_ids: product.id,
    //   content_type: "product_group",
    //   value: currentPrice.value,
    //   currency: product.currency,
    // };
    // logger(["fbq_data", fbq_data]);
    // fbq("track", "AddToCart", fbq_data);
    // fbq("track", "InitiateCheckout", fbq_data);
    
    // make sure iCart is gone
    removeICart();

    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        // have to timeout to outsmart iCart opening
        setTimeout(function () {
          window.location.href = "/checkout";
        }, 1000);
        return false;
      },
    });
  }

  $(".stay-container a").click(function (e) {
    logger("stay-container a click");
    e.preventDefault();
  });

  $(".rtx-subscribe-label").click(function (e) {
    logger("rtx-subscribe-label click");
    e.preventDefault();
    e.stopPropagation();
    const rechargeCheckbox = $(".recharge-subscribe");
    const subscribeFrequency = $(".subscribe-frequency");

    if ($(this).siblings(".recharge-subscribe").is(":checked")) {
      window.lpStayAttr.subscriptionChecked = false;
      subscribeFrequency.hide();
      rechargeCheckbox.prop("checked", false);
    } else {
      window.lpStayAttr.subscriptionChecked = true;
      rechargeCheckbox.prop("checked", true);
      subscribeFrequency.show();
    }

    switchSubscriptionPricing();
    updateActivePrices();
  });

  const stayFrequencies = document.querySelectorAll(".rtx-frequency");

  stayFrequencies.forEach((stayFrequency) => {
    stayFrequency.addEventListener("change", () => {
      updateFrequencyFromEl($(stayFrequency));
      updateUseCase();
    });
  });
};

// slider
const setupSlider = () => {
  const openBtns = document.querySelectorAll("#open");
  const closeBtn = document.querySelector(".close-btn");
  const disableSidebar = document.querySelector(".sidebar");
  const sidebar = document.querySelector(".sidebar");
  const cons = document.querySelector("#cons");
  const addBodyClass = document.querySelector("body");

  const closeFunction = () => {
    logger("closeFunction");
    cons.style.transform = "translateX(700px)";
    setTimeout(() => {
      sidebar.classList.remove("active-sidebar");
      sidebar.style.width = "0%";
      sidebar.style.position = "absolute";
      addBodyClass.style.overflowY = "visible";
      addBodyClass.classList.remove("slide");
    }, 300);
  };

  disableSidebar.addEventListener("click", (e) => {
    logger("disableSidebar click");
    let xPosition = e.clientX;
    const widthOfSectionSideBar = disableSidebar.clientWidth;
    const widthOfSidebar = cons.offsetWidth;
    if (
      xPosition < widthOfSectionSideBar - widthOfSidebar &&
      sidebar.classList.contains("active-sidebar")
    ) {
      closeFunction();
    }
  });

  openBtns.forEach((openBtn) => {
    openBtn.addEventListener("click", (e) => {
      logger("openBtn click");
      e.preventDefault();
      sidebar.classList.add("active-sidebar");
      sidebar.style.width = "100%";
      sidebar.style.position = "fixed";
      cons.style.transform = "translateX(0px)";
      addBodyClass.classList.add("slide");
    });
  });

  closeBtn.addEventListener("click", () => {
    logger("closeBtn click");
    closeFunction();
  });
};

const resetSelectedSubscription = () => {
  const rtxForm = document.querySelectorAll('input[name="rtxSubscribe"')
  rtxForm.forEach((input) => input.checked = false)
  window.lpStayAttr.subscriptionChecked = false;
}

$(document).ready(function () {
  $("#shopify-section-header").remove();
  $("body").addClass("sleepypatch-template");
  $('[data-toggle="np-tooltip"]').tooltip();

  setupForm();
  setupSlider();

  $('.subscribe-frequency .itool-skip').click(function(){
     event.preventDefault(); 
  });
});
